import Vue from "vue";
import Vuex from "vuex";

import mess from "../../../store/mess";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    mess
  }
});
